import Lookup from 'src/componentes/select-async';

import CategoriaEdit from 'src/paginas/remuneracao-variavel/categoria/edit';
import CategoriaList from 'src/paginas/remuneracao-variavel/categoria/view';

const CategoriaLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      url="/CategoriaLookup"
      editComponent={CategoriaEdit}
      searchComponent={CategoriaList}
      {...props}
    />
  );
};

export default CategoriaLookup;
